import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import MessagingAndNotification from '../MessagingAndNotification';
import Burger from '../Burger';
import { NavigationList } from '../NavigationList';
import Logo from '../Logo';
import AuthContext from 'providers/Auth/Auth.context';
import CollectionIcon from 'icons/Collection.icon';
import { isDefaultSellingPortfolio } from 'utils';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import SearchContext from 'providers/Search/Search.context';
import { buyingLink, sellingLink } from 'components/ResolveHeader/utils';
import SearchIcon from 'icons/Search.icon';
import { Button } from 'ncoded-component-library';
import { BrandingLogos } from 'types';

import './ResolveHeaderMobile.styles.scss';

type ResolveHeaderMobileProps = {
  className?: string;
  brandingLogos?: BrandingLogos;
  hasSearch: boolean;
  hasSearchForm?: boolean;
  hasMessagingLink: boolean;
  isMenuOpen: boolean;
  setIsOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
  handleOnSearch?: () => void;
};

const ResolveHeaderMobile: React.FC<ResolveHeaderMobileProps> = (props) => {
  const {
    children,
    className,
    brandingLogos,
    hasMessagingLink,
    isMenuOpen,
    hasSearch,
    hasSearchForm = true,
    setIsOpenMenu,
    handleOnSearch,
  } = props;

  const { isSearchPage, toggleSearch } = useContext(SearchContext);

  const classes = classNames('resolve-header-mobile', className);

  const closeSideBar = useCallback(() => setIsOpenMenu(false), [setIsOpenMenu]);

  const { isLoggedIn } = useContext(AuthContext);
  const { currentUser, hasEnterprise } = useContext(CurrentUserContext);
  const { hasSellingDeals } = currentUser || {};

  return (
    <div className={classes}>
      <Logo brandingLogos={brandingLogos} />

      <div className="right-menu">
        {isLoggedIn && (
          <Link
            to={
              isDefaultSellingPortfolio(hasEnterprise, hasSellingDeals)
                ? sellingLink.href
                : buyingLink.href
            }
          >
            <CollectionIcon />
          </Link>
        )}

        {hasSearch && (
          <Button variant="icon" onClick={handleOnSearch} icon={SearchIcon} />
        )}

        {hasSearchForm && !isSearchPage && (
          <Button variant="icon" onClick={toggleSearch} icon={SearchIcon} />
        )}

        <MessagingAndNotification hasMessagingLink={hasMessagingLink} />

        <Burger
          aria-label="Menu"
          open={isMenuOpen}
          onClick={() => setIsOpenMenu((prev) => !prev)}
        />
      </div>

      <div
        onClick={closeSideBar}
        className={classNames('mobile-overlay', {
          open: isMenuOpen,
        })}
      />

      <div
        className={classNames('mobile-navigation', {
          open: isMenuOpen,
        })}
      >
        <NavigationList>{children}</NavigationList>
      </div>
    </div>
  );
};

export default ResolveHeaderMobile;
